module.exports = __webpack_public_path__ + "img/round10.05deff51.png";